import React from 'react';
import { updateInvestorPreferencesMutation } from '../../../apollo';
import InvestmentPreferencesForm from './InvestmentPreferencesForm';
import AccountForm from '../AccountForm';

const InvestmentPreferences = (props) => (
  <AccountForm
    title='Investment Preferences'
    Form={InvestmentPreferencesForm}
    mutation={updateInvestorPreferencesMutation}
    {...props}
  />
);

export default InvestmentPreferences;



// WEBPACK FOOTER //
// ./src/components/Account/InvestmentPreferences/index.js